module.exports = __webpack_public_path__ + "img/bjlsjyhs.7fe192de.png";